import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`{
    "specsById": {
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Discipline",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "shortName": "Disc",
        "icon_name": "spell_holy_powerwordshield",
        "spellIds": [
          "7168b6ba-1aa8-4a30-b272-d285dfdfd722",
          "a722330c-380a-4b62-9973-2c062379d198",
          "36fdf580-d916-40a1-92bc-e09df1094870"
        ],
        "talentIds": []
      },
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Tank",
        "name": "Guardian",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "shortName": "Guard",
        "icon_name": "ability_racial_bearform",
        "spellIds": [
          "0b83b018-d870-4859-935a-02b02a8910d7"
        ],
        "talentIds": [
          "0d3830e0-ce80-452a-bb5f-18ed279a0367"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Ranged DPS",
        "name": "Balance",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "shortName": "Balance",
        "icon_name": "spell_nature_starfall",
        "spellIds": [
          "50a20f10-dc02-4054-8350-8d3d1b38aeda",
          "24cf7d57-3e53-45f3-8876-ec2656ed4d1a"
        ],
        "talentIds": [
          "dc9b1ac3-975e-4847-bcf1-830b8bffa784",
          "948a984b-eac3-413c-bc5d-2a723950c9a3"
        ]
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Frost",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "shortName": "Frost",
        "icon_name": "spell_deathknight_frostpresence",
        "spellIds": [
          "85ee4c18-8aeb-4e09-b6c4-812dc9fe40d8"
        ],
        "talentIds": []
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Holy",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "shortName": "Holy",
        "icon_name": "spell_holy_guardianspirit",
        "spellIds": [
          "2bb38a92-078d-4f43-93fd-9bc84427e9aa",
          "85228257-372c-4385-8ee8-fb461a7a8c04",
          "ee44a41b-1923-4cef-888a-3c74ad5b5739"
        ],
        "talentIds": [
          "f3481c35-2189-4f11-b8de-5e86dd101420"
        ]
      },
      "34b5a797-05ef-4431-91a0-64cc76a97624": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "role": "Ranged DPS",
        "name": "Marksman",
        "id": "34b5a797-05ef-4431-91a0-64cc76a97624",
        "shortName": "Mark",
        "icon_name": "ability_hunter_focusedaim",
        "spellIds": [
          "bdfc6636-ed1b-4759-805c-f94b7dee458c"
        ],
        "talentIds": [
          "219473f5-4a55-4a40-8b14-5353e2295484",
          "f9dc4b6a-fc03-418c-8553-c48ad55e7ac0"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Tank",
        "name": "Protection",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "shortName": "Prot",
        "icon_name": "ability_warrior_defensivestance",
        "spellIds": [
          "63fd3edd-f182-4277-9bc2-5227448e42a8"
        ],
        "talentIds": []
      },
      "c95c2375-57fa-4ae8-9d55-c2e939b82247": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "role": "Tank",
        "name": "Vengeance",
        "id": "c95c2375-57fa-4ae8-9d55-c2e939b82247",
        "shortName": "Veng",
        "icon_name": "ability_demonhunter_spectank",
        "spellIds": [
          "e04e4685-3c6e-4613-ba98-52be2140bfc8"
        ],
        "talentIds": [
          "ef337e68-02bd-4702-9df7-833a24afe198"
        ]
      },
      "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "role": "Ranged DPS",
        "name": "Beast Mastery",
        "id": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
        "shortName": "BM",
        "icon_name": "ability_hunter_bestialdiscipline",
        "spellIds": [
          "9904547d-89a3-49c1-a22b-8477c56d944f"
        ],
        "talentIds": [
          "e8feba38-2390-472a-8c0f-d53453b7e0a3",
          "f06ee4cf-d80b-4cbc-b894-b125945d54b6"
        ]
      },
      "4ac0a1e4-3352-49e9-b455-faa83312526d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Melee DPS",
        "name": "Retribution",
        "id": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "shortName": "Ret",
        "icon_name": "spell_holy_auraoflight",
        "spellIds": [
          "8edd711a-28da-4864-ba9d-1f00f6a46931",
          "d415b75d-2e26-494d-8ac3-e3990d72e552"
        ],
        "talentIds": [
          "c768ec00-4292-4429-89d6-16338f1f48a0",
          "e2840ef9-93a4-42bc-856a-c077173ec6cb"
        ]
      },
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "role": "Melee DPS",
        "name": "Havoc",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "shortName": "Havoc",
        "icon_name": "ability_demonhunter_specdps",
        "spellIds": [
          "371ee993-0b37-4c5c-b7ee-fbf47922c12a"
        ],
        "talentIds": [
          "3df7f1ed-388a-432c-aae9-d89a6c413c02"
        ]
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "role": "Healer",
        "name": "Mistweaver",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "shortName": "MW",
        "icon_name": "spell_monk_mistweaver_spec",
        "spellIds": [
          "e8bc2271-9314-42f1-a1f5-ae88a8680c48",
          "ffa5a902-f1f8-4791-b85f-942d98e2b1ab",
          "4344685d-b051-42e8-b409-6afdb24e282d",
          "135a4fba-6d15-4e2b-b38e-04e3f6ab0db4"
        ],
        "talentIds": [
          "0f57e653-9046-402a-9ad8-0c61943cdd1b",
          "4f6ebcea-8838-47c9-bade-9bafa25cf2f0",
          "69605da8-583a-4ad5-b6f6-f23200f222ee"
        ]
      },
      "cbfc9a1d-a504-4c56-8887-681e57a87211": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "role": "Ranged DPS",
        "name": "Devastation",
        "id": "cbfc9a1d-a504-4c56-8887-681e57a87211",
        "shortName": "Deva",
        "icon_name": "classicon_evoker_devastation",
        "spellIds": [
          "4dc12356-09a3-4442-a7dd-8746b5ae98c6"
        ],
        "talentIds": [
          "55d7ee77-ed89-41a1-b455-3e970e6b7953"
        ]
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Unholy",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "shortName": "Unholy",
        "icon_name": "spell_deathknight_unholypresence",
        "spellIds": [
          "96b10617-767b-4ecf-b738-4dd14bc3cfb9"
        ],
        "talentIds": []
      },
      "8fceebcc-a93b-4692-81ea-331b2e59d43d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Tank",
        "name": "Protection",
        "id": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "shortName": "Prot",
        "icon_name": "ability_paladin_shieldofthetemplar",
        "spellIds": [
          "1dd20438-062e-41fc-9b60-150a12e205d8",
          "090a619e-1731-4389-84bf-824066221b68",
          "462ad886-4345-4fad-85fa-fac8e903e14b"
        ],
        "talentIds": [
          "0642e83e-260b-4b68-a9f7-d8ea014f63af",
          "f626c934-6cf8-4f8f-8841-96202a0c7d5f",
          "c26f8c64-5da8-42a3-a32e-d1699572fb58",
          "d6d2ec6a-7fd2-4e91-b0c4-22a1b0006690"
        ]
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Healer",
        "name": "Restoration",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "shortName": "Resto",
        "icon_name": "spell_nature_healingtouch",
        "spellIds": [
          "9f7d877c-1c50-473e-a468-af9e8b53a9c8",
          "767fb9b7-37dd-42ba-a40c-3ebc4acb4010",
          "f611f7ca-0af0-4ad8-96a9-5a82046051dc",
          "0ab91fcd-99e3-4658-82de-dd8e273414b7",
          "db2f009b-fadb-4b1a-9b9b-c61d54222f9d",
          "1510469a-9ba1-43c1-b4c2-f2123f0253b7"
        ],
        "talentIds": [
          "ecf862d2-1f5d-4051-8b60-394f7658c650",
          "3065c3e8-d777-4470-9fca-84e3eb17df85",
          "b24d7519-c71a-45b0-ae8f-8f67d8d49486",
          "acfbbbfe-ac5a-4c11-a3ea-abaf9a35d147",
          "4c29d131-36ef-4125-b048-b40247ce5aeb",
          "6a5f13d8-3c24-4fcc-a52a-646e94c7a633"
        ]
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Healer",
        "name": "Holy",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "shortName": "Holy",
        "icon_name": "spell_holy_holybolt",
        "spellIds": [
          "3846c905-8ea9-401d-a120-24c00625d626",
          "1c9cd6e6-241a-4898-97cd-2073a87cd100",
          "30612a47-b815-4536-80c4-9591b5cfb835",
          "87736791-5723-4077-a94e-0735a5e83caf",
          "a721705c-3168-460c-8848-b8f49ec56edc",
          "1a2d4e71-b8d1-4493-a738-f71eaeb3b066",
          "48d6f993-15a9-4ce3-8229-f6fb2518b968",
          "62c12f15-fc62-4829-8e3b-19331db707ff"
        ],
        "talentIds": [
          "ab80adb7-32c5-4f56-ac5a-e409b7dbbe8c",
          "9f3e900e-d603-4680-a9d5-f15fda9fc476",
          "b4459e28-d8a8-4b10-8eb8-5d33bb8f2d41",
          "17741eb6-03a6-4415-b3aa-1ac530d2c15f",
          "54829dae-e511-41e0-b84d-a2c7f7118193",
          "61c37b98-60a2-44e1-ba66-0fdf77e8672f",
          "1fa30335-b205-426c-b05b-1336b6909284",
          "cde03164-1f42-4fb3-b35d-8a1a67cd67a3"
        ]
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Ranged DPS",
        "name": "Elemental",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "shortName": "Ele",
        "icon_name": "spell_nature_lightning",
        "spellIds": [
          "f1a10dbb-6694-40bb-900a-5832eb7549e8",
          "2688e14f-9ab8-4ff1-a94d-e8b1d6ed44d2"
        ],
        "talentIds": [
          "162019f6-c1da-47c2-8f26-fa424834d3ce",
          "cb550fdf-9247-4ba7-810d-bf67a7521a9b"
        ]
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Arms",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "shortName": "Arms",
        "icon_name": "ability_warrior_savageblow",
        "spellIds": [
          "eb7f280b-fddb-401b-9231-bc3966bc14bd"
        ],
        "talentIds": []
      },
      "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "role": "Ranged DPS",
        "name": "Arcane",
        "id": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "shortName": "Arcane",
        "icon_name": "spell_holy_magicalsentry",
        "spellIds": [
          "ef9f4ad9-2f93-446a-b140-4e263547a9ed",
          "f128efa6-46b2-47bc-aa4d-6ba09b4d2f57",
          "574858f4-6ebe-4ee8-a9dc-1969597ab9fc"
        ],
        "talentIds": [
          "ac075186-5490-4191-bee9-1ec0823abdf7",
          "aaf37b95-0085-4639-9602-be6b1753278a",
          "9a601219-977a-4013-81bc-2d45fd4a62ec"
        ]
      },
      "0c9d68bc-e126-4a07-817a-72c37094e005": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "role": "Melee DPS",
        "name": "Survival",
        "id": "0c9d68bc-e126-4a07-817a-72c37094e005",
        "shortName": "Surv",
        "icon_name": "ability_hunter_camouflage",
        "spellIds": [
          "3a2c34cc-d5b8-43e6-a6fd-95b72c8a42c0"
        ],
        "talentIds": [
          "c8e80f4b-eefb-4f31-b295-3d8385dabec6",
          "df268adf-2a25-496d-b38a-5c8fa0cdd5c0"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Melee DPS",
        "name": "Feral",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "shortName": "Feral",
        "icon_name": "ability_druid_catform",
        "spellIds": [
          "4c530f97-f5bf-4a44-9ef4-7665d52443d9",
          "142cc025-1301-4a24-b1fa-ce9566dd5841"
        ],
        "talentIds": [
          "239e81c1-01b0-408c-a3ea-5d83e39ac762",
          "a822f63b-ce23-47b4-af79-103272ccadf2"
        ]
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Healer",
        "name": "Restoration",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "shortName": "Resto",
        "icon_name": "spell_nature_magicimmunity",
        "spellIds": [
          "cde29f6d-52dd-49ab-9735-34387e9cb8fc",
          "ede426dc-090c-4de8-9c37-f4b1138f9332",
          "dde6f793-a6d7-4bb2-bd6d-83b653d842aa",
          "daaf9638-1f3f-450e-a93b-8ee13339503f",
          "cc4bca89-c8c1-4758-a38e-fccd7d68e40b",
          "f58b02db-feda-424e-8b2a-c2460f5b2fee"
        ],
        "talentIds": [
          "851b8250-fcd0-441d-8e38-e00fc49fbb3e",
          "4538ad0b-71d9-4839-8693-ad4ae30cace0",
          "cda274b2-d1a6-4309-b051-f7fec31494ee",
          "6a915c76-3b01-4cbb-8392-41cf5f0fd833"
        ]
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Melee DPS",
        "name": "Enhancement",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "shortName": "Enh",
        "icon_name": "spell_shaman_improvedstormstrike",
        "spellIds": [
          "2f13afef-0601-4b78-9bb0-b7067d1ef3e0",
          "44fc835d-64fe-4843-9c6b-5a808caf0d86"
        ],
        "talentIds": [
          "7b7c8cac-4bb2-471f-8930-6ded0c65dfc3",
          "2af369b8-61ce-41b0-b5b5-ae44989730ca"
        ]
      },
      "48a205f0-5e24-4382-9e0b-3c06cfc1b873": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "role": "Healer",
        "name": "Preservation",
        "id": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "shortName": "Pres",
        "icon_name": "classicon_evoker_preservation",
        "spellIds": [
          "1695c86e-1a64-45ef-aa57-8e0810a98d26",
          "726d5073-10f7-40ba-a1f3-e818e7afd765",
          "bd18abad-602e-47fd-a585-3c578a81577c",
          "dd0ea003-497d-4f6a-b1dd-c8c3ff0a8ad5",
          "907c88f7-71a2-4c4e-adc1-57b2b8236319"
        ],
        "talentIds": [
          "dcf18038-8a03-4a87-86d0-e6d42a164387",
          "aeec4741-91dd-4594-8beb-123c85ea78d3",
          "25ecce2b-54db-4b4a-8b45-242aa720ac22",
          "6404320f-c19f-48f6-b39b-bbe984b2025d",
          "22bf8521-2831-41ad-a5a5-a62a3d43bc81"
        ]
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Tank",
        "name": "Blood",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "shortName": "Blood",
        "icon_name": "spell_deathknight_bloodpresence",
        "spellIds": [
          "05a72789-b350-4e67-bfe4-a6f5744a0582"
        ],
        "talentIds": []
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Ranged DPS",
        "name": "Shadow",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "shortName": "Shadow",
        "icon_name": "spell_shadow_shadowwordpain",
        "spellIds": [
          "9aaddd21-d0a6-4b3d-b80a-d477e2404f97"
        ],
        "talentIds": [
          "81b4f418-a848-425c-b233-19adc9483cca"
        ]
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Fury",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "shortName": "Fury",
        "icon_name": "ability_warrior_innerrage",
        "spellIds": [
          "ddb5c9de-60ed-415c-87fa-d72735ec48e5"
        ],
        "talentIds": []
      }
    },
    "patchInfo": {
      "buildVersion": "1001_1"
    },
    "talentsById": {
      "6a915c76-3b01-4cbb-8392-41cf5f0fd833": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ancestral Protection Totem",
        "id": "6a915c76-3b01-4cbb-8392-41cf5f0fd833",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "81b4f418-a848-425c-b233-19adc9483cca": {
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "name": "San'layn",
        "id": "81b4f418-a848-425c-b233-19adc9483cca",
        "shortName": "San",
        "icon_name": "achievement_boss_lanathel",
        "game_id": 199855
      },
      "b4459e28-d8a8-4b10-8eb8-5d33bb8f2d41": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Unwavering Spirit",
        "id": "b4459e28-d8a8-4b10-8eb8-5d33bb8f2d41",
        "shortName": "Spirit",
        "icon_name": "spell_holy_fanaticism",
        "game_id": 392911
      },
      "219473f5-4a55-4a40-8b14-5353e2295484": {
        "specId": "34b5a797-05ef-4431-91a0-64cc76a97624",
        "name": "Born To Be Wild (1/2)",
        "id": "219473f5-4a55-4a40-8b14-5353e2295484",
        "shortName": "BtbW",
        "icon_name": "ability_hunter_aspectoftheviper",
        "game_id": 266921
      },
      "e8feba38-2390-472a-8c0f-d53453b7e0a3": {
        "specId": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
        "name": "Born To Be Wild (1/2)",
        "id": "e8feba38-2390-472a-8c0f-d53453b7e0a3",
        "shortName": "BtbW",
        "icon_name": "ability_hunter_aspectoftheviper",
        "game_id": 266921
      },
      "9f3e900e-d603-4680-a9d5-f15fda9fc476": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Tyr's Deliverance",
        "id": "9f3e900e-d603-4680-a9d5-f15fda9fc476",
        "shortName": "Tyr",
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "game_id": 200652
      },
      "cde03164-1f42-4fb3-b35d-8a1a67cd67a3": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Improved Blessing of Protection",
        "id": "cde03164-1f42-4fb3-b35d-8a1a67cd67a3",
        "shortName": "Imp Blessing",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 384909
      },
      "cb550fdf-9247-4ba7-810d-bf67a7521a9b": {
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Ancestral Guidance",
        "id": "cb550fdf-9247-4ba7-810d-bf67a7521a9b",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "54829dae-e511-41e0-b84d-a2c7f7118193": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Blessing of Protection",
        "id": "54829dae-e511-41e0-b84d-a2c7f7118193",
        "shortName": "BoP",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 1022
      },
      "aeec4741-91dd-4594-8beb-123c85ea78d3": {
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Time Spiral",
        "id": "aeec4741-91dd-4594-8beb-123c85ea78d3",
        "shortName": "Spiral",
        "icon_name": "ability_evoker_timespiral",
        "game_id": 374968
      },
      "4f6ebcea-8838-47c9-bade-9bafa25cf2f0": {
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Invoke Chi-Ji, the Red Crane",
        "id": "4f6ebcea-8838-47c9-bade-9bafa25cf2f0",
        "shortName": "Chi",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "ecf862d2-1f5d-4051-8b60-394f7658c650": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Cenarius' Guidance",
        "id": "ecf862d2-1f5d-4051-8b60-394f7658c650",
        "shortName": "Guide",
        "icon_name": "ability_druid_treeoflife",
        "game_id": 393371
      },
      "ac075186-5490-4191-bee9-1ec0823abdf7": {
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "name": "Personal 2min",
        "id": "ac075186-5490-4191-bee9-1ec0823abdf7",
        "shortName": "Pers",
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "game_id": 373905
      },
      "2af369b8-61ce-41b0-b5b5-ae44989730ca": {
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "name": "Ancestral Guidance",
        "id": "2af369b8-61ce-41b0-b5b5-ae44989730ca",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "4c29d131-36ef-4125-b048-b40247ce5aeb": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Incarnation: Tree of Life",
        "id": "4c29d131-36ef-4125-b048-b40247ce5aeb",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "f626c934-6cf8-4f8f-8841-96202a0c7d5f": {
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Unbreakable Spirit",
        "id": "f626c934-6cf8-4f8f-8841-96202a0c7d5f",
        "shortName": "Unbr",
        "icon_name": "spell_holy_holyguidance",
        "game_id": 114154
      },
      "3065c3e8-d777-4470-9fca-84e3eb17df85": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Improved Ironbark",
        "id": "3065c3e8-d777-4470-9fca-84e3eb17df85",
        "shortName": "Imp. IB",
        "icon_name": "spell_druid_ironbark",
        "game_id": 382552
      },
      "ef337e68-02bd-4702-9df7-833a24afe198": {
        "specId": "c95c2375-57fa-4ae8-9d55-c2e939b82247",
        "name": "Pitch Black",
        "id": "ef337e68-02bd-4702-9df7-833a24afe198",
        "shortName": "Pitch",
        "icon_name": "sha_spell_warlock_demonsoul",
        "game_id": 389783
      },
      "f9dc4b6a-fc03-418c-8553-c48ad55e7ac0": {
        "specId": "34b5a797-05ef-4431-91a0-64cc76a97624",
        "name": "Born To Be Wild (2/2)",
        "id": "f9dc4b6a-fc03-418c-8553-c48ad55e7ac0",
        "shortName": "BtbW",
        "icon_name": "ability_hunter_aspectoftheviper",
        "game_id": 266921
      },
      "239e81c1-01b0-408c-a3ea-5d83e39ac762": {
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "name": "Improved Stampeding Roar",
        "id": "239e81c1-01b0-408c-a3ea-5d83e39ac762",
        "shortName": "Imp. Roar",
        "icon_name": "spell_druid_stamedingroar",
        "game_id": 288826
      },
      "6a5f13d8-3c24-4fcc-a52a-646e94c7a633": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Improved Stampeding Roar",
        "id": "6a5f13d8-3c24-4fcc-a52a-646e94c7a633",
        "shortName": "Imp. Roar",
        "icon_name": "spell_druid_stamedingroar",
        "game_id": 288826
      },
      "f06ee4cf-d80b-4cbc-b894-b125945d54b6": {
        "specId": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
        "name": "Born To Be Wild (2/2)",
        "id": "f06ee4cf-d80b-4cbc-b894-b125945d54b6",
        "shortName": "BtbW",
        "icon_name": "ability_hunter_aspectoftheviper",
        "game_id": 266921
      },
      "17741eb6-03a6-4415-b3aa-1ac530d2c15f": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Unbreakable Spirit",
        "id": "17741eb6-03a6-4415-b3aa-1ac530d2c15f",
        "shortName": "Unbr",
        "icon_name": "spell_holy_holyguidance",
        "game_id": 114154
      },
      "b24d7519-c71a-45b0-ae8f-8f67d8d49486": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Inner Peace",
        "id": "b24d7519-c71a-45b0-ae8f-8f67d8d49486",
        "shortName": "IP",
        "icon_name": "ability_druid_dreamstate",
        "game_id": 197073
      },
      "aaf37b95-0085-4639-9602-be6b1753278a": {
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "name": "Healthstone",
        "id": "aaf37b95-0085-4639-9602-be6b1753278a",
        "shortName": "HS",
        "icon_name": "warlock_-healthstone",
        "game_id": 6262
      },
      "f3481c35-2189-4f11-b8de-5e86dd101420": {
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy Word: Salvation",
        "id": "f3481c35-2189-4f11-b8de-5e86dd101420",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "0f57e653-9046-402a-9ad8-0c61943cdd1b": {
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Gift of the Celestials",
        "id": "0f57e653-9046-402a-9ad8-0c61943cdd1b",
        "shortName": "Gift",
        "icon_name": "inv_pet_jadeserpentpet",
        "game_id": 388212
      },
      "3df7f1ed-388a-432c-aae9-d89a6c413c02": {
        "specId": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "name": "Pitch Black",
        "id": "3df7f1ed-388a-432c-aae9-d89a6c413c02",
        "shortName": "Pitch",
        "icon_name": "sha_spell_warlock_demonsoul",
        "game_id": 389783
      },
      "851b8250-fcd0-441d-8e38-e00fc49fbb3e": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ascendance",
        "id": "851b8250-fcd0-441d-8e38-e00fc49fbb3e",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "61c37b98-60a2-44e1-ba66-0fdf77e8672f": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Avenging Crusader",
        "id": "61c37b98-60a2-44e1-ba66-0fdf77e8672f",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "4538ad0b-71d9-4839-8693-ad4ae30cace0": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ancestral Guidance",
        "id": "4538ad0b-71d9-4839-8693-ad4ae30cace0",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "dcf18038-8a03-4a87-86d0-e6d42a164387": {
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Emerald Communion",
        "id": "dcf18038-8a03-4a87-86d0-e6d42a164387",
        "shortName": "Com",
        "icon_name": "ability_evoker_green_01",
        "game_id": 370960
      },
      "0642e83e-260b-4b68-a9f7-d8ea014f63af": {
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Uther's Counsel (1/2)",
        "id": "0642e83e-260b-4b68-a9f7-d8ea014f63af",
        "shortName": "Counsel",
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "game_id": 378425
      },
      "c768ec00-4292-4429-89d6-16338f1f48a0": {
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "name": "Unbreakable Spirit",
        "id": "c768ec00-4292-4429-89d6-16338f1f48a0",
        "shortName": "Unbr",
        "icon_name": "spell_holy_holyguidance",
        "game_id": 114154
      },
      "22bf8521-2831-41ad-a5a5-a62a3d43bc81": {
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Dream Flight",
        "id": "22bf8521-2831-41ad-a5a5-a62a3d43bc81",
        "shortName": "Dream",
        "icon_name": "ability_evoker_dreamflight",
        "game_id": 359816
      },
      "dc9b1ac3-975e-4847-bcf1-830b8bffa784": {
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "name": "Improved Stampeding Roar",
        "id": "dc9b1ac3-975e-4847-bcf1-830b8bffa784",
        "shortName": "Imp. Roar",
        "icon_name": "spell_druid_stamedingroar",
        "game_id": 288826
      },
      "25ecce2b-54db-4b4a-8b45-242aa720ac22": {
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Erasure",
        "id": "25ecce2b-54db-4b4a-8b45-242aa720ac22",
        "shortName": "Erasure",
        "icon_name": "ability_bossmagistrix_timewarp2",
        "game_id": 376210
      },
      "c8e80f4b-eefb-4f31-b295-3d8385dabec6": {
        "specId": "0c9d68bc-e126-4a07-817a-72c37094e005",
        "name": "Born To Be Wild (1/2)",
        "id": "c8e80f4b-eefb-4f31-b295-3d8385dabec6",
        "shortName": "BtbW",
        "icon_name": "ability_hunter_aspectoftheviper",
        "game_id": 266921
      },
      "df268adf-2a25-496d-b38a-5c8fa0cdd5c0": {
        "specId": "0c9d68bc-e126-4a07-817a-72c37094e005",
        "name": "Born To Be Wild (2/2)",
        "id": "df268adf-2a25-496d-b38a-5c8fa0cdd5c0",
        "shortName": "BtbW",
        "icon_name": "ability_hunter_aspectoftheviper",
        "game_id": 266921
      },
      "55d7ee77-ed89-41a1-b455-3e970e6b7953": {
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211",
        "name": "Time Spiral",
        "id": "55d7ee77-ed89-41a1-b455-3e970e6b7953",
        "shortName": "Spiral",
        "icon_name": "ability_evoker_timespiral",
        "game_id": 374968
      },
      "0d3830e0-ce80-452a-bb5f-18ed279a0367": {
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "name": "Improved Stampeding Roar",
        "id": "0d3830e0-ce80-452a-bb5f-18ed279a0367",
        "shortName": "Imp. Roar",
        "icon_name": "spell_druid_stamedingroar",
        "game_id": 288826
      },
      "c26f8c64-5da8-42a3-a32e-d1699572fb58": {
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Improved Blessing of Protection",
        "id": "c26f8c64-5da8-42a3-a32e-d1699572fb58",
        "shortName": "Imp Blessing",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 384909
      },
      "e2840ef9-93a4-42bc-856a-c077173ec6cb": {
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "name": "Improved Blessing of Protection",
        "id": "e2840ef9-93a4-42bc-856a-c077173ec6cb",
        "shortName": "Imp Blessing",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 384909
      },
      "6404320f-c19f-48f6-b39b-bbe984b2025d": {
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Temporal Artificer",
        "id": "6404320f-c19f-48f6-b39b-bbe984b2025d",
        "shortName": "Temp. Art",
        "icon_name": "ability_evoker_rewind",
        "game_id": 381922
      },
      "1fa30335-b205-426c-b05b-1336b6909284": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Sacrifice of the Just",
        "id": "1fa30335-b205-426c-b05b-1336b6909284",
        "shortName": "Just",
        "icon_name": "spell_holy_sealofsacrifice",
        "game_id": 384820
      },
      "d6d2ec6a-7fd2-4e91-b0c4-22a1b0006690": {
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Uther's Counsel (2/2)",
        "id": "d6d2ec6a-7fd2-4e91-b0c4-22a1b0006690",
        "shortName": "Counsel",
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "game_id": 378425
      },
      "948a984b-eac3-413c-bc5d-2a723950c9a3": {
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "name": "Nature's Vigil",
        "id": "948a984b-eac3-413c-bc5d-2a723950c9a3",
        "shortName": "Vigil",
        "icon_name": "achievement_zone_feralas",
        "game_id": 124974
      },
      "162019f6-c1da-47c2-8f26-fa424834d3ce": {
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Wind Rush Totem",
        "id": "162019f6-c1da-47c2-8f26-fa424834d3ce",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "69605da8-583a-4ad5-b6f6-f23200f222ee": {
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Chrysalis",
        "id": "69605da8-583a-4ad5-b6f6-f23200f222ee",
        "shortName": "Chrys",
        "icon_name": "ability_monk_domeofmist",
        "game_id": 202424
      },
      "cda274b2-d1a6-4309-b051-f7fec31494ee": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Wind Rush Totem",
        "id": "cda274b2-d1a6-4309-b051-f7fec31494ee",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "7b7c8cac-4bb2-471f-8930-6ded0c65dfc3": {
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "name": "Wind Rush Totem",
        "id": "7b7c8cac-4bb2-471f-8930-6ded0c65dfc3",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "9a601219-977a-4013-81bc-2d45fd4a62ec": {
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "name": "HP Pot",
        "id": "9a601219-977a-4013-81bc-2d45fd4a62ec",
        "shortName": "Pot",
        "icon_name": "inv_potion_49",
        "game_id": 370511
      },
      "a822f63b-ce23-47b4-af79-103272ccadf2": {
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "name": "Nature's Vigil",
        "id": "a822f63b-ce23-47b4-af79-103272ccadf2",
        "shortName": "Vigil",
        "icon_name": "achievement_zone_feralas",
        "game_id": 124974
      },
      "acfbbbfe-ac5a-4c11-a3ea-abaf9a35d147": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Convoke the Spirits",
        "id": "acfbbbfe-ac5a-4c11-a3ea-abaf9a35d147",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 391528
      },
      "ab80adb7-32c5-4f56-ac5a-e409b7dbbe8c": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy Avenger",
        "id": "ab80adb7-32c5-4f56-ac5a-e409b7dbbe8c",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      }
    },
    "spellsById": {
      "907c88f7-71a2-4c4e-adc1-57b2b8236319": {
        "affectedByModifierIds": [],
        "talentId": "dcf18038-8a03-4a87-86d0-e6d42a164387",
        "name": "Emerald Communion",
        "cooldown": 180,
        "id": "907c88f7-71a2-4c4e-adc1-57b2b8236319",
        "shortName": "Com",
        "icon_name": "ability_evoker_green_01",
        "game_id": 370960
      },
      "8edd711a-28da-4864-ba9d-1f00f6a46931": {
        "affectedByModifierIds": [],
        "name": "Divine Shield",
        "cooldown": 300,
        "id": "8edd711a-28da-4864-ba9d-1f00f6a46931",
        "shortName": "Div",
        "icon_name": "spell_holy_divineshield",
        "game_id": 642
      },
      "9f7d877c-1c50-473e-a468-af9e8b53a9c8": {
        "affectedByModifierIds": [],
        "talentId": "acfbbbfe-ac5a-4c11-a3ea-abaf9a35d147",
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "id": "9f7d877c-1c50-473e-a468-af9e8b53a9c8",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 391528
      },
      "1510469a-9ba1-43c1-b4c2-f2123f0253b7": {
        "affectedByModifierIds": [],
        "name": "Ironbark",
        "cooldown": 90,
        "id": "1510469a-9ba1-43c1-b4c2-f2123f0253b7",
        "shortName": "IB",
        "icon_name": "spell_druid_ironbark",
        "game_id": 102342
      },
      "bdfc6636-ed1b-4759-805c-f94b7dee458c": {
        "affectedByModifierIds": [],
        "name": "Aspect of the Turtle",
        "cooldown": 180,
        "id": "bdfc6636-ed1b-4759-805c-f94b7dee458c",
        "shortName": "Turtle",
        "icon_name": "ability_hunter_pet_turtle",
        "game_id": 186265
      },
      "2f13afef-0601-4b78-9bb0-b7067d1ef3e0": {
        "affectedByModifierIds": [],
        "talentId": "7b7c8cac-4bb2-471f-8930-6ded0c65dfc3",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "2f13afef-0601-4b78-9bb0-b7067d1ef3e0",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "dde6f793-a6d7-4bb2-bd6d-83b653d842aa": {
        "affectedByModifierIds": [],
        "talentId": "cda274b2-d1a6-4309-b051-f7fec31494ee",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "dde6f793-a6d7-4bb2-bd6d-83b653d842aa",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "24cf7d57-3e53-45f3-8876-ec2656ed4d1a": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "24cf7d57-3e53-45f3-8876-ec2656ed4d1a",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "4dc12356-09a3-4442-a7dd-8746b5ae98c6": {
        "affectedByModifierIds": [],
        "talentId": "55d7ee77-ed89-41a1-b455-3e970e6b7953",
        "name": "Time Spiral",
        "cooldown": 120,
        "id": "4dc12356-09a3-4442-a7dd-8746b5ae98c6",
        "shortName": "Spiral",
        "icon_name": "ability_evoker_timespiral",
        "game_id": 374968
      },
      "f611f7ca-0af0-4ad8-96a9-5a82046051dc": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "f611f7ca-0af0-4ad8-96a9-5a82046051dc",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "a722330c-380a-4b62-9973-2c062379d198": {
        "affectedByModifierIds": [],
        "name": "Rapt",
        "cooldown": 90,
        "id": "a722330c-380a-4b62-9973-2c062379d198",
        "shortName": "Rapt",
        "icon_name": "spell_holy_rapture",
        "game_id": 47536
      },
      "48d6f993-15a9-4ce3-8229-f6fb2518b968": {
        "affectedByModifierIds": [],
        "name": "Blessing of Sacrifice",
        "cooldown": 120,
        "id": "48d6f993-15a9-4ce3-8229-f6fb2518b968",
        "shortName": "Sac",
        "icon_name": "spell_holy_sealofsacrifice",
        "game_id": 6940
      },
      "4c530f97-f5bf-4a44-9ef4-7665d52443d9": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "4c530f97-f5bf-4a44-9ef4-7665d52443d9",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "cc4bca89-c8c1-4758-a38e-fccd7d68e40b": {
        "affectedByModifierIds": [],
        "name": "Healing Tide Totem",
        "cooldown": 180,
        "id": "cc4bca89-c8c1-4758-a38e-fccd7d68e40b",
        "shortName": "HTT",
        "icon_name": "ability_shaman_healingtide",
        "game_id": 108280
      },
      "ee44a41b-1923-4cef-888a-3c74ad5b5739": {
        "affectedByModifierIds": [],
        "name": "Symbol of Hope",
        "cooldown": 180,
        "id": "ee44a41b-1923-4cef-888a-3c74ad5b5739",
        "shortName": "Hope",
        "icon_name": "spell_holy_symbolofhope",
        "game_id": 64901
      },
      "87736791-5723-4077-a94e-0735a5e83caf": {
        "affectedByModifierIds": [],
        "name": "Divine Shield",
        "cooldown": 300,
        "id": "87736791-5723-4077-a94e-0735a5e83caf",
        "shortName": "Div",
        "icon_name": "spell_holy_divineshield",
        "game_id": 642
      },
      "0ab91fcd-99e3-4658-82de-dd8e273414b7": {
        "affectedByModifierIds": [],
        "name": "Tranquility",
        "cooldown": 180,
        "id": "0ab91fcd-99e3-4658-82de-dd8e273414b7",
        "shortName": "Tranq",
        "icon_name": "spell_nature_tranquility",
        "game_id": 740
      },
      "dd0ea003-497d-4f6a-b1dd-c8c3ff0a8ad5": {
        "affectedByModifierIds": [],
        "talentId": "22bf8521-2831-41ad-a5a5-a62a3d43bc81",
        "name": "Dream Flight",
        "cooldown": 120,
        "id": "dd0ea003-497d-4f6a-b1dd-c8c3ff0a8ad5",
        "shortName": "Dream",
        "icon_name": "ability_evoker_dreamflight",
        "game_id": 359816
      },
      "ef9f4ad9-2f93-446a-b140-4e263547a9ed": {
        "affectedByModifierIds": [],
        "talentId": "9a601219-977a-4013-81bc-2d45fd4a62ec",
        "name": "HP Pot",
        "cooldown": 300,
        "id": "ef9f4ad9-2f93-446a-b140-4e263547a9ed",
        "shortName": "Pot",
        "icon_name": "inv_potion_49",
        "game_id": 370511
      },
      "9904547d-89a3-49c1-a22b-8477c56d944f": {
        "affectedByModifierIds": [],
        "name": "Aspect of the Turtle",
        "cooldown": 180,
        "id": "9904547d-89a3-49c1-a22b-8477c56d944f",
        "shortName": "Turtle",
        "icon_name": "ability_hunter_pet_turtle",
        "game_id": 186265
      },
      "daaf9638-1f3f-450e-a93b-8ee13339503f": {
        "affectedByModifierIds": [],
        "name": "Spirit Link Totem",
        "cooldown": 180,
        "id": "daaf9638-1f3f-450e-a93b-8ee13339503f",
        "shortName": "SLT",
        "icon_name": "spell_shaman_spiritlink",
        "game_id": 98008
      },
      "1dd20438-062e-41fc-9b60-150a12e205d8": {
        "affectedByModifierIds": [],
        "name": "Blessing of Protection",
        "cooldown": 300,
        "id": "1dd20438-062e-41fc-9b60-150a12e205d8",
        "shortName": "BoP",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 1022
      },
      "36fdf580-d916-40a1-92bc-e09df1094870": {
        "affectedByModifierIds": [],
        "name": "Evang",
        "cooldown": 90,
        "id": "36fdf580-d916-40a1-92bc-e09df1094870",
        "shortName": "Evang",
        "icon_name": "spell_holy_divineillumination",
        "game_id": 246287
      },
      "62c12f15-fc62-4829-8e3b-19331db707ff": {
        "affectedByModifierIds": [],
        "talentId": "61c37b98-60a2-44e1-ba66-0fdf77e8672f",
        "name": "Avenging Crusader",
        "cooldown": 45,
        "id": "62c12f15-fc62-4829-8e3b-19331db707ff",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "142cc025-1301-4a24-b1fa-ce9566dd5841": {
        "affectedByModifierIds": [],
        "talentId": "a822f63b-ce23-47b4-af79-103272ccadf2",
        "name": "Nature's Vigil",
        "cooldown": 90,
        "id": "142cc025-1301-4a24-b1fa-ce9566dd5841",
        "shortName": "Vigil",
        "icon_name": "achievement_zone_feralas",
        "game_id": 124974
      },
      "7168b6ba-1aa8-4a30-b272-d285dfdfd722": {
        "affectedByModifierIds": [],
        "name": "Power Word: Barrier",
        "cooldown": 180,
        "id": "7168b6ba-1aa8-4a30-b272-d285dfdfd722",
        "shortName": "PW:B",
        "icon_name": "spell_holy_powerwordbarrier",
        "game_id": 62618
      },
      "462ad886-4345-4fad-85fa-fac8e903e14b": {
        "affectedByModifierIds": [],
        "name": "Blessing of Spellwarding",
        "cooldown": 300,
        "id": "462ad886-4345-4fad-85fa-fac8e903e14b",
        "shortName": "Ward",
        "icon_name": "spell_holy_blessingofprotection",
        "game_id": 204018
      },
      "50a20f10-dc02-4054-8350-8d3d1b38aeda": {
        "affectedByModifierIds": [],
        "talentId": "948a984b-eac3-413c-bc5d-2a723950c9a3",
        "name": "Nature's Vigil",
        "cooldown": 90,
        "id": "50a20f10-dc02-4054-8350-8d3d1b38aeda",
        "shortName": "Vigil",
        "icon_name": "achievement_zone_feralas",
        "game_id": 124974
      },
      "090a619e-1731-4389-84bf-824066221b68": {
        "affectedByModifierIds": [],
        "name": "Divine Shield",
        "cooldown": 300,
        "id": "090a619e-1731-4389-84bf-824066221b68",
        "shortName": "Div",
        "icon_name": "spell_holy_divineshield",
        "game_id": 642
      },
      "85228257-372c-4385-8ee8-fb461a7a8c04": {
        "affectedByModifierIds": [],
        "talentId": "f3481c35-2189-4f11-b8de-5e86dd101420",
        "name": "Holy Word: Salvation",
        "cooldown": 720,
        "id": "85228257-372c-4385-8ee8-fb461a7a8c04",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "767fb9b7-37dd-42ba-a40c-3ebc4acb4010": {
        "affectedByModifierIds": [],
        "talentId": "4c29d131-36ef-4125-b048-b40247ce5aeb",
        "name": "Incarnation: Tree of Life",
        "cooldown": 180,
        "id": "767fb9b7-37dd-42ba-a40c-3ebc4acb4010",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "574858f4-6ebe-4ee8-a9dc-1969597ab9fc": {
        "affectedByModifierIds": [],
        "talentId": "ac075186-5490-4191-bee9-1ec0823abdf7",
        "name": "Personal 2min",
        "cooldown": 120,
        "id": "574858f4-6ebe-4ee8-a9dc-1969597ab9fc",
        "shortName": "Pers",
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "game_id": 373905
      },
      "db2f009b-fadb-4b1a-9b9b-c61d54222f9d": {
        "affectedByModifierIds": [],
        "name": "Flourish",
        "cooldown": 90,
        "id": "db2f009b-fadb-4b1a-9b9b-c61d54222f9d",
        "shortName": "Flou",
        "icon_name": "spell_druid_wildburst",
        "game_id": 197721
      },
      "ffa5a902-f1f8-4791-b85f-942d98e2b1ab": {
        "affectedByModifierIds": [],
        "name": "Life Cocoon",
        "cooldown": 120,
        "id": "ffa5a902-f1f8-4791-b85f-942d98e2b1ab",
        "shortName": "Coco",
        "icon_name": "ability_monk_chicocoon",
        "game_id": 116849
      },
      "e8bc2271-9314-42f1-a1f5-ae88a8680c48": {
        "affectedByModifierIds": [],
        "name": "Revival",
        "cooldown": 180,
        "id": "e8bc2271-9314-42f1-a1f5-ae88a8680c48",
        "shortName": "Rev",
        "icon_name": "spell_monk_revival",
        "game_id": 115310
      },
      "cde29f6d-52dd-49ab-9735-34387e9cb8fc": {
        "affectedByModifierIds": [],
        "talentId": "4538ad0b-71d9-4839-8693-ad4ae30cace0",
        "name": "Ancestral Guidance",
        "cooldown": 120,
        "id": "cde29f6d-52dd-49ab-9735-34387e9cb8fc",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "ede426dc-090c-4de8-9c37-f4b1138f9332": {
        "affectedByModifierIds": [],
        "talentId": "851b8250-fcd0-441d-8e38-e00fc49fbb3e",
        "name": "Ascendance",
        "cooldown": 180,
        "id": "ede426dc-090c-4de8-9c37-f4b1138f9332",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "e04e4685-3c6e-4613-ba98-52be2140bfc8": {
        "affectedByModifierIds": [],
        "name": "Darkness",
        "cooldown": 300,
        "id": "e04e4685-3c6e-4613-ba98-52be2140bfc8",
        "shortName": "Dark",
        "icon_name": "ability_demonhunter_darkness",
        "game_id": 196718
      },
      "2688e14f-9ab8-4ff1-a94d-e8b1d6ed44d2": {
        "affectedByModifierIds": [],
        "talentId": "162019f6-c1da-47c2-8f26-fa424834d3ce",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "2688e14f-9ab8-4ff1-a94d-e8b1d6ed44d2",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "bd18abad-602e-47fd-a585-3c578a81577c": {
        "affectedByModifierIds": [],
        "name": "Time Dilation",
        "cooldown": 60,
        "id": "bd18abad-602e-47fd-a585-3c578a81577c",
        "shortName": "Dia",
        "icon_name": "ability_evoker_timedilation",
        "game_id": 357170
      },
      "1a2d4e71-b8d1-4493-a738-f71eaeb3b066": {
        "affectedByModifierIds": [],
        "talentId": "54829dae-e511-41e0-b84d-a2c7f7118193",
        "name": "Blessing of Protection",
        "cooldown": 300,
        "id": "1a2d4e71-b8d1-4493-a738-f71eaeb3b066",
        "shortName": "BoP",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 1022
      },
      "f1a10dbb-6694-40bb-900a-5832eb7549e8": {
        "affectedByModifierIds": [],
        "talentId": "cb550fdf-9247-4ba7-810d-bf67a7521a9b",
        "name": "Ancestral Guidance",
        "cooldown": 120,
        "id": "f1a10dbb-6694-40bb-900a-5832eb7549e8",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "135a4fba-6d15-4e2b-b38e-04e3f6ab0db4": {
        "affectedByModifierIds": [],
        "talentId": "4f6ebcea-8838-47c9-bade-9bafa25cf2f0",
        "name": "Invoke Chi-Ji, the Red Crane",
        "cooldown": 180,
        "id": "135a4fba-6d15-4e2b-b38e-04e3f6ab0db4",
        "shortName": "Chi",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "1695c86e-1a64-45ef-aa57-8e0810a98d26": {
        "affectedByModifierIds": [],
        "talentId": "aeec4741-91dd-4594-8beb-123c85ea78d3",
        "name": "Time Spiral",
        "cooldown": 120,
        "id": "1695c86e-1a64-45ef-aa57-8e0810a98d26",
        "shortName": "Spiral",
        "icon_name": "ability_evoker_timespiral",
        "game_id": 374968
      },
      "d415b75d-2e26-494d-8ac3-e3990d72e552": {
        "affectedByModifierIds": [],
        "name": "Blessing of Protection",
        "cooldown": 300,
        "id": "d415b75d-2e26-494d-8ac3-e3990d72e552",
        "shortName": "BoP",
        "icon_name": "spell_holy_sealofprotection",
        "game_id": 1022
      },
      "96b10617-767b-4ecf-b738-4dd14bc3cfb9": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "96b10617-767b-4ecf-b738-4dd14bc3cfb9",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "f58b02db-feda-424e-8b2a-c2460f5b2fee": {
        "affectedByModifierIds": [],
        "talentId": "6a915c76-3b01-4cbb-8392-41cf5f0fd833",
        "name": "Ancestral Protection Totem",
        "cooldown": 300,
        "id": "f58b02db-feda-424e-8b2a-c2460f5b2fee",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "3846c905-8ea9-401d-a120-24c00625d626": {
        "affectedByModifierIds": [],
        "name": "Aura Mastery",
        "cooldown": 180,
        "id": "3846c905-8ea9-401d-a120-24c00625d626",
        "shortName": "AM",
        "icon_name": "spell_holy_auramastery",
        "game_id": 31821
      },
      "eb7f280b-fddb-401b-9231-bc3966bc14bd": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "eb7f280b-fddb-401b-9231-bc3966bc14bd",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "85ee4c18-8aeb-4e09-b6c4-812dc9fe40d8": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "85ee4c18-8aeb-4e09-b6c4-812dc9fe40d8",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "3a2c34cc-d5b8-43e6-a6fd-95b72c8a42c0": {
        "affectedByModifierIds": [],
        "name": "Aspect of the Turtle",
        "cooldown": 180,
        "id": "3a2c34cc-d5b8-43e6-a6fd-95b72c8a42c0",
        "shortName": "Turtle",
        "icon_name": "ability_hunter_pet_turtle",
        "game_id": 186265
      },
      "05a72789-b350-4e67-bfe4-a6f5744a0582": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "05a72789-b350-4e67-bfe4-a6f5744a0582",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "4344685d-b051-42e8-b409-6afdb24e282d": {
        "affectedByModifierIds": [],
        "name": "Invoke Yu'lon, the Jade Serpent",
        "cooldown": 180,
        "id": "4344685d-b051-42e8-b409-6afdb24e282d",
        "shortName": "Yu",
        "replacedByTalentId": "4f6ebcea-8838-47c9-bade-9bafa25cf2f0",
        "icon_name": "ability_monk_dragonkick",
        "game_id": 322118
      },
      "f128efa6-46b2-47bc-aa4d-6ba09b4d2f57": {
        "affectedByModifierIds": [],
        "talentId": "aaf37b95-0085-4639-9602-be6b1753278a",
        "name": "Healthstone",
        "cooldown": 1000,
        "id": "f128efa6-46b2-47bc-aa4d-6ba09b4d2f57",
        "shortName": "HS",
        "icon_name": "warlock_-healthstone",
        "game_id": 6262
      },
      "30612a47-b815-4536-80c4-9591b5cfb835": {
        "affectedByModifierIds": [],
        "talentId": "9f3e900e-d603-4680-a9d5-f15fda9fc476",
        "name": "Tyr's Deliverance",
        "cooldown": 90,
        "id": "30612a47-b815-4536-80c4-9591b5cfb835",
        "shortName": "Tyr",
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "game_id": 200652
      },
      "9aaddd21-d0a6-4b3d-b80a-d477e2404f97": {
        "affectedByModifierIds": [],
        "name": "Vampiric Embrace",
        "cooldown": 120,
        "id": "9aaddd21-d0a6-4b3d-b80a-d477e2404f97",
        "shortName": "VE",
        "icon_name": "spell_shadow_unsummonbuilding",
        "game_id": 15286
      },
      "1c9cd6e6-241a-4898-97cd-2073a87cd100": {
        "affectedByModifierIds": [],
        "talentId": "ab80adb7-32c5-4f56-ac5a-e409b7dbbe8c",
        "name": "Holy Avenger",
        "cooldown": 180,
        "id": "1c9cd6e6-241a-4898-97cd-2073a87cd100",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "44fc835d-64fe-4843-9c6b-5a808caf0d86": {
        "affectedByModifierIds": [],
        "talentId": "2af369b8-61ce-41b0-b5b5-ae44989730ca",
        "name": "Ancestral Guidance",
        "cooldown": 120,
        "id": "44fc835d-64fe-4843-9c6b-5a808caf0d86",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "0b83b018-d870-4859-935a-02b02a8910d7": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "0b83b018-d870-4859-935a-02b02a8910d7",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "726d5073-10f7-40ba-a1f3-e818e7afd765": {
        "affectedByModifierIds": [],
        "name": "Rewind",
        "cooldown": 240,
        "id": "726d5073-10f7-40ba-a1f3-e818e7afd765",
        "shortName": "Rew",
        "icon_name": "ability_evoker_rewind",
        "game_id": 363534
      },
      "2bb38a92-078d-4f43-93fd-9bc84427e9aa": {
        "affectedByModifierIds": [],
        "name": "Divine Hymn",
        "cooldown": 180,
        "id": "2bb38a92-078d-4f43-93fd-9bc84427e9aa",
        "shortName": "Hymn",
        "icon_name": "spell_holy_divinehymn",
        "game_id": 64843
      },
      "63fd3edd-f182-4277-9bc2-5227448e42a8": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "63fd3edd-f182-4277-9bc2-5227448e42a8",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "ddb5c9de-60ed-415c-87fa-d72735ec48e5": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "ddb5c9de-60ed-415c-87fa-d72735ec48e5",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "371ee993-0b37-4c5c-b7ee-fbf47922c12a": {
        "affectedByModifierIds": [],
        "name": "Darkness",
        "cooldown": 300,
        "id": "371ee993-0b37-4c5c-b7ee-fbf47922c12a",
        "shortName": "Dark",
        "icon_name": "ability_demonhunter_darkness",
        "game_id": 196718
      },
      "a721705c-3168-460c-8848-b8f49ec56edc": {
        "affectedByModifierIds": [],
        "name": "Avenging Wrath",
        "cooldown": 120,
        "id": "a721705c-3168-460c-8848-b8f49ec56edc",
        "shortName": "Wings",
        "replacedByTalentId": "61c37b98-60a2-44e1-ba66-0fdf77e8672f",
        "icon_name": "spell_holy_avenginewrath",
        "game_id": 31884
      }
    },
    "changelog": [
      "- All of DF"
    ],
    "modifiersById": {}
  }`)
